import { render } from "./supportModal.vue?vue&type=template&id=73d58c6b&scoped=true"
import script from "./supportModal.vue?vue&type=script&lang=js"
export * from "./supportModal.vue?vue&type=script&lang=js"

import "./supportModal.vue?vue&type=style&index=0&id=73d58c6b&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d58c6b"]])

export default __exports__